import { makeStyles } from '@material-ui/core';
import { rem, vw } from 'src/common/helpers/dimension-helper';
import { themeColor } from 'src/mui-theme';

export const styles = makeStyles(() => ({
  dialogPaper: {
    minHeight: '95.96vh',
    minWidth: '97.51vw',
    maxWidth: '97.51vw',
    borderRadius: 'unset',
    backgroundColor: themeColor.lightBackground,
    overflowY: 'hidden',
    '& button': {
      fontSize: rem(1),
      letterSpacing: '0.4px',
    },
  },
  mainContent: {
    padding: '2.34vh 1.47vw 0 1.47vw',
    rowGap: '1.5vw',
  },
  contentTitle: {
    height: '3.38vh',
    fontSize: rem(1.5),
    fontFamily: '"Roboto", Helvetica, Arial, sans-serif',
    fontWeight: 500,
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 'normal',
    letterSpacing: '1.2px',
    color: themeColor.defaultTextColor,
  },
  subContentTitle: {
    fontSize: rem(1.125),
    fontFamily: '"Roboto", Helvetica, Arial, sans-serif',
    fontWeight: 500,
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: '3.12vh',
    letterSpacing: '1.25px',
    color: themeColor.defaultTextColor,
  },
  customerLoyaltySearch: {
    backgroundColor: themeColor.white,
    boxShadow: `0 1px 4px 0 ${themeColor.almosttransparentblack}`,
    width: '94.29vw',
    height: '7.29vh',
    borderBottom: `1px solid ${themeColor.secondaryLight}`,
    padding: '0 1.2vw',
    cursor: 'pointer',
  },
  customerLoyaltyHeaderRow: {
    padding: '0 1.2vw',
    fontWeight: 500,
    '& span': {
      color: themeColor.subheaderLight,
    },
  },
  selectedCustomer: {
    border: `2px solid ${themeColor.secondaryMain}`,
  },
  customerSearchResultsList: {
    fontSize: rem(0.875),
    fontFamily: '"Roboto", Helvetica, Arial, sans-serif',
    fontWeight: 500,
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: '3.12vh',
    letterSpacing: '0.15px',
    color: themeColor.bigstone,
    opacity: 0.8,
  },
  firstNameItem: {
    flex: 1,
  },
  lastNameItem: {
    flex: 1,
  },
  activeIcon: {
    flex: 1,
    '& .MuiChip-root': {
      display: 'none',
    },
  },
  inactiveCustomer: {
    opacity: 0.5,
    cursor: 'default',
    '& .MuiChip-root': {
      backgroundColor: themeColor.trainingColor,
      display: 'flex',
    },
  },
  chip: {
    '& span': {
      paddingLeft: '1.4vw',
      paddingRight: '1.4vw',
    },
  },
  mobileItem: {
    flex: 1,
  },
  homePhoneItem: {
    flex: 1,
  },
  searchCustomerBackButton: {
    color: themeColor.defaultTextColor,
  },
  searchCustomerBackIcon: {
    color: themeColor.buttonIconGrey,
    '& svg': {
      fontSize: `${rem(1.5)} !important`,
    },
  },
  addCustomerItem: {
    paddingLeft: '0.73vw',
  },
  closeButton: {
    color: themeColor.defaultTextColor,
    minWidth: vw(7.6135),
  },
  addCustomerButton: {
    '&:disabled': {
      opacity: '1',
      color: themeColor.rollingStone,
      background: themeColor.progressBar,
      '& span': {
        opacity: 1,
      },
    },
    minWidth: vw(7.32),
  },
  wrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  trainingModeBackground: {
    minHeight: '96vh',
    maxHeight: '96vh',
    minWidth: '97.5vw',
    maxWidth: '97.5vw',
    borderRadius: 'unset',
    backgroundColor: themeColor.trainingBackground,
  },
}));
